import React from "react";
import PropTypes from "prop-types";
import numeral from 'numeral';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from '@material-ui/core/Snackbar';

import Check from "@material-ui/icons/Check";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

import vecLogo from "../../../assets/img/Header-Logo.png";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx";

import { STATICS_URL } from '../../../config/constants';

import CustomNotification from "../../LandingPage/Sections/CustomNotification";

class SectionFiltered extends React.Component {
    totalTours = 0;

    constructor(props) {
        super(props);

        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: ''
        };
    }

    componentDidMount() {
        this.handleClickNotification('Tours filtrados exitosamente', 'success');
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    // onChangeSlide = () => {
    //     if (this.refs.NoUiSlider) {
    //         let newArray = this.refs.NoUiSlider.slider.get();
    //         newArray[0] = Number(newArray[0].slice(0, 3));
    //         newArray[1] = Number(newArray[1].slice(0, 3));
    //         let currencyLow = this.refs.priceLow.dataset.currency;
    //         let currencyHigh = this.refs.priceLow.dataset.currency;
    //         this.refs.priceLow.innerHTML = currencyLow + newArray[0];
    //         this.refs.priceHigh.innerHTML = currencyHigh + newArray[1];
    //     }
    // };

    render() {
        const { classes, filtersReducer } = this.props;
        const { filteredTours } = filtersReducer;

        this.totalTours = filteredTours.length;

        let tourCards = (
            filteredTours.map(tour =>
                <GridItem md={12} sm={12} key={tour._id}>
                    <Card plain blog className={classes.card}>
                        <GridContainer>
                            <GridItem xs={5} sm={5} md={4} className={classes.vecImgContainer+" "+classes.dashed}>
                                <CardHeader image plain>
                                    {/**
                                     TODO: Revisar asunto slugs para URL del tour
                                     */}
                                    <Link to={`/tour/${tour._id}`}>
                                        <img
                                            className={classes.vecImg}
                                            src={tour.photos.length>0 ? STATICS_URL+tour.photos[0].path : vecLogo}
                                            alt={tour.name}
                                        />
                                    </Link>
                                    {/* Shadow img */}
                                    {tour.photos.length>0 ?
                                        <div
                                            className={classes.coloredShadow+" "+classes.vecImg}
                                            style={{ backgroundImage: `url(${tour.photos.length>0 ? STATICS_URL+tour.photos[0].path : vecLogo})`, opacity: 1 }}
                                        />
                                        :
                                        null
                                    }
                                    {/* End Shadow img */}
                                </CardHeader>
                            </GridItem>

                            <GridItem xs={7} sm={7} md={6}>
                                {/*<Info>
                                    <h6 className={classes.cardCategory}>ENTERPRISE</h6>
                                </Info>*/}
                                <Link to={`/tour/${tour._id}`}>
                                    <h3 className={classes.cardTitle}>{tour.name}</h3>
                                </Link>
                                <p className={classes.author}><strong>Duración: {tour.duration} día(s)</strong></p>
                                <Card className={classes.vecCardActivities+" "+classes.cardPricing}>
                                    <ul>
                                        {tour.activities.map( (activity, index) => {
                                            while (index < 3) {
                                                return <li key={index}><Check className={classes.cardIcons+" "+classes.successColor}/>{activity}</li>
                                            }

                                            return true;
                                        })}
                                        <li><Check className={classes.cardIcons+" "+classes.successColor}/>Y más...</li>
                                    </ul>
                                    <br/>
                                </Card>
                                {tour.observations ? <p className={classes.vecAdvice}>{tour.observations}</p> : null}
                            </GridItem>

                            <GridItem xs={12} sm={12} md={2} className={classes.dashed}>
                                {isMobile ?
                                    <div className={classes.vecPriceContainer}>
                                        <GridContainer>
                                            <GridItem xs={8} sm={8} md={8}>
                                                <span>{tour.min_persons} - {tour.max_persons} pasajeros</span>
                                                <br/>
                                                <span>Desde</span>
                                                {(!!tour.pricing && tour.pricing.low_season) ?
                                                    <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.low_season).format('0,0')}</h3>
                                                    :
                                                    <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.high_season).format('0,0')}</h3>
                                                }
                                                <div>
                                                    <span>Por persona (IVA no incl.)</span>
                                                </div>
                                            </GridItem>
                                            <GridItem xs={4} sm={4} md={4}>
                                                <br/>
                                                <br/>
                                                <Link to={`/tour/${tour._id}`}>
                                                    <Button color="success">
                                                        Elegir
                                                    </Button>
                                                </Link>
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                    :
                                    <div className={classes.vecPriceContainer}>
                                        <span>{tour.min_persons} - {tour.max_persons} pasajeros</span>
                                        <br/>
                                        <br/>
                                        <span>Desde</span>
                                        {(!!tour.pricing && tour.pricing.low_season) ?
                                            <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.low_season).format('0,0')}</h3>
                                            :
                                            <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.high_season).format('0,0')}</h3>
                                        }

                                        <div>
                                            <span>Por persona <br/> (IVA no incl.)</span>
                                        </div>
                                        <Link to={`/tour/${tour._id}`}>
                                            <Button color="success">
                                                Elegir
                                            </Button>
                                        </Link>
                                    </div>
                                }
                            </GridItem>
                        </GridContainer>
                    </Card>

                    <hr/>
                    <br/>
                    <br/>

                </GridItem>
            )
        );


        return (
            <div>
                <h2>{this.totalTours} Tours encontrados:</h2>
                <GridContainer>
                    {/* Custom Notification */}
                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                    </Snackbar>
                    {/* End Custom Notification */}

                    {/* Products catalog */}
                    <GridItem md={12} sm={12}>
                        <GridContainer>

                            {tourCards}

                        </GridContainer>
                    </GridItem>
                    {/* End Products catalog */}

                </GridContainer>
            </div>
        );
    }
}

SectionFiltered.propTypes = {
    filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
    filtersReducer: state.filtersReducer
});

export default connect(mapStateToProps, null)( withStyles(styles)(SectionFiltered) );



// WEBPACK FOOTER //
// ./src/views/ToursPage/Sections/SectionFiltered.jsx